<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="2 0 18 18">
    <g>
      <path
        d="M17.0939 11.0889C17.8997 10.4174 18.4226 9.37783 18.4226 8.20591C18.4226 6.18493 16.875 4.54167 14.9716 4.54167C13.0682 4.54167 11.5206 6.18493 11.5206 8.20591C11.5206 9.37783 12.0436 10.4206 12.8524 11.0921C12.2473 11.3762 11.7061 11.7798 11.25 12.2673C10.7939 11.7765 10.2497 11.373 9.64155 11.0889C10.4473 10.4174 10.9703 9.37783 10.9703 8.20591C10.9703 6.18493 9.42264 4.54167 7.51926 4.54167C5.61588 4.54167 4.06824 6.18493 4.06824 8.20591C4.06824 9.37783 4.59122 10.4206 5.4 11.0921C3.5179 11.9735 2.25 13.9848 2.25 16.1995C2.25 16.3867 2.39291 16.5417 2.5723 16.5417C2.75169 16.5417 2.89459 16.3899 2.89459 16.1995C2.89459 14.0881 4.20811 12.1898 6.09628 11.5409C6.53108 11.7507 7.01149 11.8702 7.5223 11.8702C8.03311 11.8702 8.51655 11.7475 8.95135 11.5376C9.675 11.783 10.3135 12.2188 10.8274 12.7773C10.122 13.7362 9.70541 14.9339 9.70541 16.1995C9.70541 16.3867 9.84831 16.5417 10.0277 16.5417C10.2071 16.5417 10.35 16.3899 10.35 16.1995C10.35 15.1373 10.6814 14.13 11.253 13.3068C11.8186 14.13 12.15 15.1373 12.15 16.1995C12.15 16.3867 12.2929 16.5417 12.4723 16.5417C12.6517 16.5417 12.7946 16.3899 12.7946 16.1995C12.7946 14.9339 12.3811 13.7362 11.6818 12.7773C12.1956 12.2221 12.8311 11.7862 13.5547 11.5376C13.9895 11.7475 14.4699 11.8669 14.9807 11.8669C15.4916 11.8669 15.975 11.7442 16.4098 11.5344C18.2949 12.1736 19.6054 14.0784 19.6054 16.1962C19.6054 16.3835 19.7483 16.5384 19.9277 16.5384C20.1071 16.5384 20.25 16.3867 20.25 16.1962C20.25 13.9751 18.9821 11.9606 17.1061 11.0857L17.0939 11.0889ZM7.51926 11.189C5.97162 11.189 4.7098 9.8524 4.7098 8.20591C4.7098 6.55942 5.96858 5.22286 7.51926 5.22286C9.06993 5.22286 10.3287 6.55942 10.3287 8.20591C10.3287 9.8524 9.06993 11.189 7.51926 11.189ZM14.9716 11.189C13.424 11.189 12.1622 9.8524 12.1622 8.20591C12.1622 6.55942 13.4209 5.22286 14.9716 5.22286C16.5223 5.22286 17.7811 6.55942 17.7811 8.20591C17.7811 9.8524 16.5223 11.189 14.9716 11.189Z"
        stroke="white"
        stroke-width="0.3"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath>
        <rect width="21" height="21" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>
